const filteredSearchName = (value: string) =>
  value
    ?.trim()
    .replace(/[^\S\r\n]{2,}/g, ' ')
    .toLowerCase();

export default filteredSearchName;
